<template>
    <div class="search-mobile__inner" ref="search">
        <form class="search-mobile__form" action="." @submit.prevent="submit">
            <div class="container">
                <!-- TODO: Make this editable in CMS -->
                <label :for="`search-${_uid}`" class="search__heading">Search</label>
                <div class="search__text">Let us help you find what it is that you're looking for.</div>
                <search-input :id="_uid" :clear-text="true" v-model="query" ref="input" />
            </div>
        </form>
        <div class="container">
            <results :items="results" :query="query" :id="_uid" :suggestedTopResults="topResults" @keydown.enter="submit" />
        </div>
    </div>
</template>

<script>
import $ from 'wee-dom';
import $mediator from 'wee-mediator';
import debounce from 'lodash.debounce';
import client from '../../../scripts/swiftypeClient';
import SearchInput from '../input/index.vue';
import Results from '../results/index.vue';

export default {
    components: {
        SearchInput,
        Results,
    },
    mounted() {
        $mediator.on(`search-${this._uid}.clear`, () => {
            this.query = '';
        });
    },
    methods: {
        submit() {
            const input = this.$refs.input.$el;

            if (input) {
                input.firstChild.blur();
            }

            this.search();
        },
        search: debounce(function() {
            if (this.query.length >= 2) {

 		client.search(this.query, {
                    search_fields: {
                        title: {},
                    },
                    filters: {
                        none: [{
                            type: 'condition',
                        }],
                    },
                    page: {
                        size: 200,
                    }
                }).then(({ results }) => {
                    this.topResults = results;
                });

                client.search(this.query, {
                    page: {
                        size: 200,
                    },
                    filters: {
                        none: {
                            type: 'condition',
                        },
                    },
                }).then(({ results, info }) => {
                    this.results = results;
                    this.info = info;
                });
            } else if (this.query.length === 0) {
                this.results = [];
                this.info = {};
            }
        }, 100),
    },
    data: () => ({
        query: '',
        results: [],
        topResults: [],
        info: {},
    }),
};
</script>

